'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// expects DOM els of both the stationary and scroller forms
// expects .scroll-form-content to only exist within the stationary form, as it will be cloned into the scroller form wrapper once activated

var ScrollForm = function () {
	function ScrollForm() {
		var _this = this;

		_classCallCheck(this, ScrollForm);

		this.$forms = $('.scroll-form');
		this.$stationaryForm = $('.scroll-form-stationary');
		this.$scrollerForm = $('.scroll-form-scroller');
		this.$waypoint = $('.scroll-form-waypoint');
		this.offset = this.calculateOffset();
		this.clonedContent = false;
		this.status = 'stationary';
		this.handleWarnings();

		this.$waypoint.waypoint({
			handler: function handler(direction) {
				if (direction === 'down' && _this.status === 'stationary') {
					_this.setScroller();
				} else if (direction === 'up' && _this.status === 'scroller') {
					_this.setStationary();
				}
			},
			offset: this.offset
		});
	}

	_createClass(ScrollForm, [{
		key: 'setScroller',
		value: function setScroller() {
			this.$stationaryForm.css('opacity', 0);

			if (!this.clonedContent) {
				var content = this.$stationaryForm.find('.scroll-form-content').clone();
				this.$scrollerForm.html(content);
			}

			this.$scrollerForm.css('opacity', 1);
			this.$scrollerForm.find('.scroll-form-content').css('top', this.calculateOffset());
			this.status = 'scroller';
		}
	}, {
		key: 'setStationary',
		value: function setStationary() {
			this.$stationaryForm.css('opacity', 1);
			this.$scrollerForm.css('opacity', 0);
			this.status = 'stationary';
		}
	}, {
		key: 'calculateOffset',
		value: function calculateOffset() {
			var offset = 0;
			var $header = $('#site-header');
			var $secondaryNav = $('.nav-secondary');

			if ($header) offset += $header.outerHeight();
			if ($secondaryNav) offset += $header.outerHeight();

			return offset;
		}
	}, {
		key: 'handleWarnings',
		value: function handleWarnings() {
			if (this.$stationaryForm.length < 1) console.warn('Looks like no `.scroll-form.scroll-form-stationary` element was found. This is required for ScrollForm.js');
			if (this.$scrollerForm.length < 1) console.warn('Looks like no `.scroll-form.scroll-form-scroller` element was found. This is required for ScrollForm.js');
			if (this.$waypoint.length < 1) console.warn('Looks like no `.scroll-form-waypoint` element was found. This is required for ScrollForm.js');
		}
	}]);

	return ScrollForm;
}();